module.exports = __webpack_public_path__ + "static/media/cv.79659b21.png";